import _ from 'lodash';

export const getChannelId = (state) => _.get(state, 'channelInfo.info.id');

export const getCurrentChannelId = (state) =>
  state.currentChannelId.currentChannelId;
